<div class="flex h-svh flex-col">
  <app-header-catalogue-national [filtres]="filtres()" (filtrer)="filtrerFormations($event)" />
  <section class="m-lg h-full overflow-y-auto bg-white !py-0" hlmCard>
    <div class="!p-lg gap-xl grid" hlmCardContent>
      @for (item of data(); track $index) {
        <app-expansion-panel [titre]="getTitre(item.equipeResponsable)">
          <div class="p-xs gap-xs grid">
            @for (referentiel of item.referentiels | trierPar: 'nom'; track referentiel.id) {
              <app-expansion-panel [item]="referentiel" [titre]="referentiel.nom">
                <div class="p-md gap-md grid grid-cols-3">
                  @for (etape of referentiel.etapes | trierPar: 'nom'; track etape.id) {
                    <app-card-etape [etape]="etape" />
                  } @empty {
                    <span class="text-content-secondary paragraph-medium-medium pl-sm"
                      >Il n’y a pas encore d'étapes associées.</span
                    >
                  }
                </div>
              </app-expansion-panel>
            } @empty {
              <span class="paragraph-medium-medium text-content-secondary pl-md">Pas de référentiels.</span>
            }
          </div>
        </app-expansion-panel>
      } @empty {
        <app-empty-state title="Aucun résultat ne correpond à votre recherche.">
          <span class="text-content-secondary text-center"
            >Modifiez vos critères de recherche pour avoir des résultats.</span
          >
        </app-empty-state>
      }
    </div>
  </section>
</div>
